<template>
  <div class="user-status-filter-item positioning">
    <label
      class="item-label"
      v-t.preserve="'appUserStatusFilterPositioning.positioning'"
    />
    <filter-button-group bordered v-model="value" v-bind:buttons="buttons" />
  </div>
</template>

<script>
import FilterButtonGroup from '@/components/AppFilterButtonGroup.vue'

export default {
  name: 'AppUserStatusFilterPositioning',
  components: {
    FilterButtonGroup,
  },
  props: {
    /**
     * 選択値
     * 「すべて」を選択する場合は null にする
     */
    isPositioning: {
      type: Boolean,
      default: null,
    },
  },
  data: function () {
    return {
      // ローカル値
      value: this.isPositioning,
    }
  },
  computed: {
    /**
     * 選択肢のボタン定義
     * @type {Array.<Object>}
     */
    buttons: function () {
      return [
        { value: null, text: this.$t('appUserStatusFilterPositioning.all') },
        {
          value: true,
          text: this.$t('appUserStatusFilterPositioning.inPositioning'),
        },
        {
          value: false,
          text: this.$t('appUserStatusFilterPositioning.notInPositioning'),
        },
      ]
    },
    /**
     * イベント返却用の値
     * @type {Object}
     */
    resultValue: function () {
      return { isPositioning: this.value }
    },
    /**
     * イベント返却用のテキスト
     * @type {String}
     */
    resultText: function () {
      return this.value == null
        ? ''
        : this.buttons.find((b) => b.value === this.value)?.text || ''
    },
  },
  watch: {
    isPositioning: function (value) {
      this.value = value
    },
    value: function () {
      this.$_onChange()
    },
  },
  mounted: function () {
    // 初回結果表示のためにpropsの値で変更されたことにする
    this.$_onChange()
  },
  methods: {
    /**
     * 変更時処理
     */
    $_onChange: function () {
      /**
       * 選択値変更イベント
       * @param {Object} value 選択値
       * @param {String} text 選択値表示テキスト
       */
      this.$emit('changed', { value: this.resultValue, text: this.resultText })
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../assets/scss/parts/user/user-status-filter-item';

::v-deep .filter-button-group {
  justify-content: flex-start;
}
</style>
